function getMonthDiff(startDate, endDate) {
  let months;
  months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
  months -= startDate.getMonth();
  months += endDate.getMonth();
  return months <= 0 ? 0 : months;
}

function getMonthAbreviation(month) {
  switch (month) {
    case 1:
      return "Ene";
    case 2:
      return "Feb";
    case 3:
      return "Mar";
    case 4:
      return "Abr";
    case 5:
      return "May";
    case 6:
      return "Jun";
    case 7:
      return "Jul";
    case 8:
      return "Ago";
    case 9:
      return "Sep";
    case 10:
      return "Oct";
    case 11:
      return "Nov";
    default:
      return "Dic";
  }
}

function getMonthName(month) {
  switch (month) {
    case 1:
      return "Enero";
    case 2:
      return "Febrero";
    case 3:
      return "Marzo";
    case 4:
      return "Abril";
    case 5:
      return "Mayo";
    case 6:
      return "Junio";
    case 7:
      return "Julio";
    case 8:
      return "Agosto";
    case 9:
      return "Septiembre";
    case 10:
      return "Octubre";
    case 11:
      return "Noviembre";
    default:
      return "Diciembre";
  }
}

/**
 * Colombia timezone (America/Bogota, UTC-5).
 * Returns current date in YYYY-MM-DD format for Colombia.
 */
function getColombiaDateString() {
  const now = new Date();
  return now.toLocaleDateString("en-CA", { timeZone: "America/Bogota" });
}

/**
 * Returns current time in HH:mm format for Colombia (UTC-5).
 */
function getColombiaTimeString() {
  const now = new Date();
  return now.toLocaleTimeString("en-GB", {
    timeZone: "America/Bogota",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}

/**
 * Extracts YYYY-MM-DD from a date string (handles "2026-02-05" or "2026-02-05T00:00:00.000Z").
 * Avoids timezone shifts when backend returns UTC midnight.
 */
function parseDateOnly(dateValue) {
  if (!dateValue) return null;
  const str = String(dateValue).trim();
  const match = str.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (match) return match[0]; // YYYY-MM-DD
  return null;
}

/**
 * Formats a date string for display as DD/MM/YYYY in Colombia, without timezone conversion.
 * Use this for date-only values (fecha_viaje, fecha_cargue, etc.) to avoid the -1 day bug
 * when the backend returns UTC midnight.
 */
function formatDateOnlyForDisplay(dateValue) {
  const ymd = parseDateOnly(dateValue);
  if (!ymd) return "";
  const [y, m, d] = ymd.split("-");
  return `${d.padStart(2, "0")}/${m.padStart(2, "0")}/${y}`;
}

/**
 * Returns true if the given date (YYYY-MM-DD or ISO string) is before today in Colombia.
 * Compares date-only to avoid timezone issues in deployed environments.
 */
function isFechaVencidaColombia(dateValue) {
  const fechaYmd = parseDateOnly(dateValue);
  if (!fechaYmd) return false;
  const hoyColombia = getColombiaDateString();
  return fechaYmd < hoyColombia;
}

module.exports = {
  getMonthDiff,
  getMonthAbreviation,
  getMonthName,
  getColombiaDateString,
  getColombiaTimeString,
  parseDateOnly,
  formatDateOnlyForDisplay,
  isFechaVencidaColombia,
};
